import { MomentumSidebar } from 'features/momentum/components/Sidebar/Sidebar';
import {
  IDraftSprint,
  ISprint,
  SprintsType,
} from 'features/sprint/config/types';
import { BridgeModeTimelineItem } from 'features/timeline/BridgeModeTimelineItem';
import { SprintTimelineItem } from 'features/timeline/SprintTimelineItem';

import { useOpenSidebar } from 'shared/components/Sidebar';

export const useMomentumSidebar = ({
  sprint,
  sprints,
  dateRange,
}: {
  sprint: ISprint | IDraftSprint | SprintTimelineItem | BridgeModeTimelineItem;
  sprints: SprintsType;
  dateRange?: {
    startDate: string;
    endDate: string;
  };
}) => {
  const { openSidebar } = useOpenSidebar({
    content: <MomentumSidebar />,
    props: { title: 'Momentum Feed' },
    context: {
      sprint,
      sprints,
      dateRange,
    },
  });

  return { openSidebar };
};
